import { render, staticRenderFns } from "./ListViewVendors.vue?vue&type=template&id=510001aa&"
import script from "./ListViewVendors.vue?vue&type=script&lang=js&"
export * from "./ListViewVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports